import { Localization } from '../../localization/localization';
import { onPayFinish } from '../game_general';
import { PaymentStatus } from '../../constants/paymentStatus';
import { Url } from '../modules/url';
import { getUserSuid } from '../modules/getUserSuid';
import { CurrentEntryPoint } from '../../constants/CurrentEntryPoint';
import urlParse from 'url-parse';
import { WindowData } from './types/windowData';
import { PaymentObject } from '../../types/payments';
import { PaymentServices } from '../../payments/paymentServices';
import { PayService } from '../../payments/PayService';
import { CurrentUser } from '../modules/user/currentUser';

export function generateMailForm():HTMLElement {
    window.app.order_box.hideOrderBoxElements();
    const popupInfo = document.querySelector('#ecommpay_order_box_popup_order_info');
    popupInfo.removeAttribute('style');

    const mailBlock = document.createElement('div');
    mailBlock.setAttribute('class', 'mail_block ecommpay_variant');
    mailBlock.setAttribute('style', 'text-align:center; width:250px;');
    mailBlock.innerHTML = `<p style="padding-bottom: 10px;">${Localization._n('support.emptyEmail')}</p>
    <div class='ecommpay_order_box_popup_order_price_line_bprice' style="width:230px; text-align: left;">
    <input type='text' placeholder='' class='email'/></div>
    <div class='ecommpay_order_box_popup_order_price_line_bprice2'></div>`;

    const forwardButton = document.createElement('button');
    forwardButton.innerText = Localization._n('faketutor.dialog.greeting.continue');
    forwardButton.className = 'font2 green_middle_button noselected center';
    forwardButton.id = 'mailBtn';
    forwardButton.setAttribute('style', 'margin-left: 25px;');
    mailBlock.appendChild(forwardButton);

    return mailBlock;
}


let stopWatchingPaymentWindow: (() => void) | null = null;

/** Also takes the blackout down, which the watcher would otherwise have removed on close. */
export function stopPaymentWindowWatcher() {
    if (stopWatchingPaymentWindow) {
        stopWatchingPaymentWindow();
    }
}

export function showWindow(windowData: WindowData): Window | null {
    const $blackout = $('<div class="blackout">');
    const windowCheckDelay = 100;

    $('body').append($blackout);
    const paymentWindow: Window | null = window.open(
        windowData.windowRequestUrl,
        windowData.windowName,
        windowData.windowFeatures.join(',')
    );

    if (!paymentWindow) {
        $blackout.remove();

        return null;
    }

    $blackout.on('click', function handleBlackoutClick() {
        paymentWindow.focus();
    });

    const windowCheckInterval: Timer = window.setInterval(function checkWindowState() {
        if (typeof paymentWindow === 'undefined' || !paymentWindow || paymentWindow.closed) {
            stopWatching();
            window.app.game_popup_close();
            onPayFinish(PaymentStatus.CANCEL, window.app.last_payment);
            window.app.order_box.hideOrderBoxElements();
        }
    }, windowCheckDelay);

    // Each popup tears down its own interval and blackout, whatever opened since.
    function stopWatching() {
        clearInterval(windowCheckInterval);
        $blackout.remove();

        if (stopWatchingPaymentWindow === stopWatching) {
            stopWatchingPaymentWindow = null;
        }
    }

    stopWatchingPaymentWindow = stopWatching;

    return paymentWindow;
}

export function showFrame(windowData: WindowData): HTMLIFrameElement {
    window.app.order_box.hideOrderBoxElements();
    const frame = window.app.order_box.appendIframe(
        // @ts-ignore
        windowData.windowRequestUrl,
        620,
        580,
        '.ecommpay_order_box_popup_wrapper',
        false
    );
    // eslint-disable-next-line func-names,id-length
    frame.addEventListener('onPayFinish', function(e) {
        console.log(e);
    });

    return frame;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function showPayInfoOnBox(url:any) {
    window.app.order_box.hideOrderBoxElements();
    window.app.order_box.appendIframe(
        // @ts-ignore
        url,
        620,
        580,
        '.ecommpay_order_box_popup_wrapper',
        false
    );
}

// eslint-disable-next-line max-params
export function getPaymentResultUrls(
    type: string,
    errorInfo?: PaymentError,
    code?: PaymentStatus,
    // Callers whose result arrives later pass the descriptor they captured; the order box clears it.
    windowData?: PaymentWindowData
) {
    const paymentResultUrls = {error: '', success: ''};
    const paymentData: PaymentWindowData = windowData ?? getPaymentWindowData(type);
    const UrlParse = urlParse(Url.getNoLangUrl('/payments/result?window=0'), true);
    UrlParse.set('query', {
        ...UrlParse.query,
        amount: paymentData.amount,
        currency: paymentData.currency,
        description: paymentData.name,
        error: 0,
        orderId: paymentData.pm_id,
        // The legacy path sends none, and the result page then reports 0 to the game client.
        ...code === undefined ? {} : {code}
    });

    paymentResultUrls.success = UrlParse.toString();

    UrlParse.set('query', {
        ...UrlParse.query,
        error: 1
    });

    if (errorInfo) {
        UrlParse.set('query', {
            ...UrlParse.query,
            error: 1,
            errorMessage: errorInfo.message,
            errorCode: errorInfo.code
        });
    }
    paymentResultUrls.error = UrlParse.toString();

    return paymentResultUrls;
}


export function getWindowConfig(): WindowOptions {
    return {
        innerHeight: 700,
        innerWidth: 750,
        left: window.screen && window.screen.availWidth ? (window.screen.availWidth / 2) - 583 / 2 : 22,
        location: 0,
        menubar: 0,
        scrollbars: 1,
        toolbar: 0,
        top: window.screen && window.screen.availHeight ? (window.screen.availHeight / 2) - 667 / 2 : 22
    };
}

export function getPaymentWindowData(type: string):PaymentWindowData {
    return {
        amount: window.app.last_payment_object.price,
        country: window.app.config.country,
        currency: window.app.last_payment_object.currency,
        currentEntryPoint: window.app.config.current_entry_point,
        email: encodeURIComponent(CurrentUser.getInstance().getEmail() || ''),
        guid_receiver: window.app.last_payment_object.guid_receiver,
        locale: window.app.config.locale,
        method: type,
        name: window.app.last_payment_object.name,
        pm_id: window.app.last_payment_object.id,
        suid: getUserSuid(),
        suid_simulate: getUserSuid(true)
    };
}

export function showPaymentLoader() {
    $('#ecommpay_order_box_popup .loader').show();
}

export function hidePaymentLoader() {
    $('#ecommpay_order_box_popup .loader').hide();
}

export function removeLinkToOtherPaymentMethods() {
    const oldButtons = document.querySelector('#linkToOtherPaymentMethods');
    if (oldButtons) {
        oldButtons.remove();
    }
}

export async function getInitiatedTransactionId(
    pmObject: PaymentObject,
    payService: PaymentServices
) {
    try {
        return await PayService.initiateTransaction(pmObject, payService);
    } catch (error) {
        window.Sentry.captureException(error);
        const url = getPaymentResultUrls('iframe', {message: error.message, code: error.code});
        showPayInfoOnBox(url.error);
    }

    return null;
}

export type WindowOptions = {
    left?: number,
    top?: number
    innerWidth?: number
    innerHeight?: number
    menubar?: 0 | 1,
    toolbar?: 0 | 1,
    location?: 0 | 1,
    scrollbars?: 1 | 0,
};

export type PaymentWindowData = {
    amount: number,
    country: string,
    currency: string,
    currentEntryPoint: CurrentEntryPoint,
    email: string | boolean,
    locale: string,
    method: string,
    pm_id: number,
    suid: string,
    suid_simulate: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    guid_receiver: any
    name: string
}

export type PaymentError = {
    message?: string,
    code?: string
}
